package com.downdogapp.client

/**
 * AUTO-GENERATED DO NOT EDIT!
 * from com.downdogapp.tasks.AppStrings
 */
// @formatter:off 
object JapaneseStrings : LanguageStrings {
  // https://worker.downdogapp.com/debug/appString?appStringId=488
  override fun ABBREVIATED_MEMBERSHIP_WILL_NOT_RENEW(p0: Any) = "キャンセル済み、${p0}に期限切れ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=498
  override val ACCOUNT = "アカウント"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2588
  override val ACCOUNT_INELIGIBLE_FOR_REFERRAL_MESSAGE = "すでにアカウントをお持ちのようです。紹介による無料メンバーシップの対象となるのは、新しいアカウントのみです。ごめん！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3956
  override val ACTIVITY = "アクティビティ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1467
  override val AFFILIATE_ANSWER = "ご興味をお持ちいただきありがとうございます！私たちはアフィリエイトプログラムを終了しましたので、残念ながら現在は提供しておりません。申し訳ありません！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1466
  override val AFFILIATE_QUESTION = "紹介プログラムまたはアフィリエイトプログラムはありますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1299
  override val AFFORDABILITY = "手頃な価格"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1300
  override val AFFORDABILITY_FEEDBACK_PROMPT = "あなたの状況について教えてください"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=518
  override val AFFORDABILITY_MESSAGE = "私たちの使命は、素晴らしいフィットネスをお求めやすい価格で世界に提供することです。もし Down Dog が予算の範囲でない場合はメッセージで状況をお知らせください。私たちに出来ることを検討させていただきます！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3973
  override val AFFORDABILITY_SUPPORT_PAGE_TITLE = "購入できませんか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3950
  override val AIRPLAY = "Airplayを起動"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1409
  override val AIRPLAY_ANSWER = "画面ミラーリングを利用して、ダウンドッグの練習をAirPlayできます！詳しくは、<a href=\"https://support.apple.com/en-us/HT204289\"> Appleのサポートページ</a>をご覧ください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1408
  override val AIRPLAY_QUESTION = "AirPlayをサポートしていますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1292
  override val ALL = "すべて"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1255
  override val ALL_APPS = "すべてのアプリ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1453
  override val ALL_APPS_PURCHASE_ANSWER = "現時点ではサブスクリプションを購入すると、Down Dog ヨガ、HIIT、バレエ、マタニティヨガなど、すべてのアプリにアクセスできます。\n\n単独のアプリを購入するオプションは現在提供していません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1452
  override val ALL_APPS_PURCHASE_QUESTION = "サブスクリプションは1つのアプリが対象ですか、それともすべてのアプリですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3110
  override val ALL_POSES = "すべてのポーズ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1295
  override fun AMOUNTS_CURRENCY_PAYMENTS_SECURE_MESSAGE(p0: Any) = "すべての金額は${p0}です。お支払い情報は暗号化され、安全です。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=113
  override val AND = "そして"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1589
  override val APPLE = "Apple"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1403
  override val APPLE_HEALTH_ANSWER = "はい！接続に問題がある場合は、次のヒントを参考にしてください。\n\n1.アプリがヘルスケアに接続されていることを確認します。アプリを開いてメニューに移動します（右下のハンバーガーボタンを押します）。ヘルスケアに接続するオプションがあれば、そのオプションをクリックします。\n2.スマートフォンでヘルスケアを開き、データソースタブをクリックします。Down Dogがデータソースとしてリストされていますか？これは、Down Dogが接続されていることを再確認するためのものです。そうでない場合は（ただし、Down Dog内に接続するオプションはありません）、私たちにお知らせしてください！\n3.アプリをアンインストールして再インストールしてから、ログインしてAppleヘルスケアに再接続してみてください。\n\n残念ながら、AppleヘルスケアはiPadではサポートされておらず、デバイス間での練習の追跡はサポートされていません（将来的には可能になるかもしれません）。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1402
  override val APPLE_HEALTH_QUESTION = "アプリは Apple ヘルスケアに接続しますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1420
  override fun APPLE_REFUND_POLICY(p0: Any) = "残念ながら、AppleはApp Storeから購入したサブスクリプションのキャンセルまたは返金を私たちがすることを許可していません。サブスクリプションのキャンセル方法については、Appleからのお知らせをご覧ください：${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1425
  override val ASK_IN_FACEBOOK_GROUP = "Facebookグループで質問する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=490
  override val AUTO_RENEW_IS_OFF = "自動更新オフ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=489
  override val AUTO_RENEW_IS_ON = "自動更新をオンにする"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1221
  override val AUTO_RENEW_OFF_ANSWER = "<b>サブスクリプションを管理またはキャンセルする方法</b>\n\nサブスクリプションを<em>ウェブサイトから</ em>購入した場合：\n1. [<b>設定</b>]に移動します。モバイルでは、画面の右下にある3本の水平線をタップします。ウェブでは、設定は左側のサイドバーにあります。\n2. [<b>設定</b>]で、[<b>購読</b>]をタップします。\n3.次に、サブスクリプションをキャンセルまたは変更する方法（自動更新をオフにするなど）を含む詳細情報が表示されます。\n\n<em>モバイルアプリから</ em>サブスクリプションを購入した場合、<a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">Apple App Store</a>または<a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\"> Google Playストア</a></a>からサブスクリプションを管理できます 。\n\n<b>サブスクリプションについて</b>\n\n当社のWebサイト、Apple、またはGoogleからご自身でメンバーシップを購入しない限り、サブスクリプションに対して請求されることはありません。サブスクリプションは購入時に使用したメールアドレスで管理されます。アカウントにサブスクリプションが表示されない場合は、現在ログインしているメールアドレスでのサブスクリプションがないことを意味します。サブスクリプションが別のメールアドレスに関連付けられている可能性があります。その場合は、ログアウトしてから、そのメールアドレスで再度ログインしてサブスクリプションを確認する必要があります。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1211
  override val AUTO_RENEW_OFF_QUESTION = "自動更新を無効にしたいです。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=252
  override val BACK = "戻る"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=787
  override val BARRE = "バレエ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=759
  override val BARRE_GOOGLE_FIT_DESCRIPTION = "バレエワークアウト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1432
  override val BILLING = "支払い"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1258
  override val BILLING_REFUND = "お支払い - 払い戻し"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=332
  override val BREATHING = "呼吸"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2538
  override val BREATHING_GOOGLE_FIT_DESCRIPTION = "ブレスワークの練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=263
  override val CANCEL = "キャンセル"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2564
  override val CANCEL_DOWNLOAD = "ダウンロードをキャンセル"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1470
  override val CANNOT_MERGE_ACCOUNTS_ANSWER = "残念ながら、アカウントを統合することはできません。\n\nアクセスするには、サブスクリプションの購入時に使用したメールアドレスでサインインしてください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1469
  override val CANNOT_MERGE_ACCOUNTS_QUESTION = "複数のアカウントを持っています。それらを統合できますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1305
  override val CANT_ACCESS_SUBSCRIPTION_ANSWER = "誤って複数の Down Dog アカウントを作成した可能性があります。アプリからログアウトし、使用していた可能性のある他のメール アドレスで再度ログインしてみてください。サブスクリプションは、当社のすべてのアプリとすべてのデバイス (Web バージョンを含む) で機能しますが、購入に使用したのと同じ電子メールでサインインする必要があることに注意してください。 <em>Apple、Google、および PayPal は、Down Dog へのログインに使用したメール アドレスではなく、これらのサービスに関連付けられているメール アドレスに領収書を送信している可能性があることに注意してください</em>。\n\nApple iTunes または Google Play を使用してモバイル アプリ内からサブスクライブした場合は、アプリのメニューから [<b>アプリ内購入を復元</b>] をクリックしてみてください。これは、元の購入を行ったのと同じアプリ内から行うようにしてください。\n\nPayPal 経由で定期購入し、定期購入にアクセスできない場合は、支払いがうまくいかなかった可能性があります。これは、PayPal アカウント内から確認するか、アプリの [設定] にアクセスして確認できます。ここでは、数日しか続かないサブスクリプションが表示されます。この場合、実際には請求されていないため、当社の Web サイトにアクセスして再度購入を試みることができます。 PayPal を使用するよりも、クレジット カードで直接支払う方が成功する可能性があります。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1304
  override val CANT_ACCESS_SUBSCRIPTION_QUESTION = "サブスクリプションにアクセスできません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3949
  override val CAST = "キャスト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1203
  override val CAST_ANSWER = "はい、先日モバイルアプリとウェブアプリにChromecastのサポートを追加しました。\n\nモバイルアプリでChromecastを使用する方法は次のとおりです。\n1. Chromecast対応デバイス（テレビなど）がオンになっていて、Android / iOSデバイスと同じWiFiネットワーク上にあることを確認します。また、アプリが最新バージョンであることを確認します。\n2.練習を始めます。\n3.画面をタップしてコントロールを表示し、右上の<b>キャストアイコン</b>（左下に無線のマークがある長方形）をタップします。\n4.練習がテレビに読み込まれるまで1分ほど待ってから、Android / iOSデバイスで[再生]をタップします。\n\nウェブアプリでChromecastを使用する方法は次のとおりです。\n1. Chromecast対応デバイス（テレビなど）がオンになっていて、コンピューターと同じWiFiネットワーク上にあることを確認します。\n2. <b> Chrome </b>を使用して、Webアプリで練習を開始します。\n3.右下の<b>キャストアイコン</b>（左下に無線のマークがある長方形）をクリックします。\n4.練習がテレビにロードされるまで1分ほど待ってから、コンピューターで[再生]をクリックします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1191
  override val CAST_QUESTION = "Chromecastをサポートしていますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1349
  override val CAST_TROUBLESHOOTING_ANSWER = "<b>キャストボタンが表示されない場合：</b>\n\n1.練習を開始してから一時停止します。キャストボタンが表示されていますか（Android / iOSの場合は右上、ウェブアプリの場合は右下）。キャストボタンは練習中にのみ表示されます。\n\n2.同じデバイスから別のもの（YouTubeなど）をキャストしてみます。キャストボタンが表示されますか？そうでない場合は、Chromecast対応デバイス（テレビなど）がオンになっていて、コンピュータまたはAndroid / iOSデバイスと同じWiFiネットワーク上にあることを確認してください。パソコンを使用している場合は、Chromeを使用していることを確認してください。\n\n3.別のデバイスからキャストしてみます。 Android / iOSを使用していた場合は、パソコンのウェブアプリから、パソコンを使用していた場合は Android / iOSからキャストしてみてください。\n\n4.スマートフォンのDown Dogアプリのバッテリー最適化をオフにしてみてください。これにより、アプリは数分間操作がない場合でも省電力モードに移行せず、Chromecastデバイスとの通信を継続できます。\n\n\n<b>「接続」しているのに動画が再生されない場合：</b>\n\nまず、Down Dogがテレビに読み込まれるまで十分に待機していることを確認します。読み込みには最大60秒かかります。この間、テレビの下部には最初に黄色の「読み込み中」バーが表示され、その後黒にフェードします。読み込みが完了すると、テレビに動画が表示されます。\n\n60秒経過してもテレビ画面が黒いままの場合、または黒い画面の真ん中に「Down Dog」という単語が表示される場合は、練習を終了してもう一度試してください。同じ練習を[履歴]タブ（Android / iOSの場合は画面下部の時計アイコン、Webの場合は左側のサイドバー）から再開できます。\n\n\n<b>数分後にキャストが切断される場合：</b>\n\n1. WiFi信号強度を確認します。 Chromecastや電話/コンピュータの信号が弱い場合は、WiFiエクステンダーを使用するか、ルーターに近づけることで信号強度を改善できます。\n\n2.スマートフォンのDown Dogアプリのバッテリー最適化をオフにします。これにより、アプリは数分間操作がない場合でも省電力モードに移行せず、Chromecastデバイスとの通信を継続できます。\n\n3.それでも問題が解決しない場合は、ルーターを再起動してみてください。\n\n4.最後に、静的IPアドレスを使用するように、電話機に保存されているWi-Fi接続設定を編集してみます。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1348
  override val CAST_TROUBLESHOOTING_QUESTION = "Chromecastに問題があります。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=997
  override fun CASTING_TO_DEVICE(p0: Any) = "${p0}にキャストする"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3302
  override val CHALLENGE_EMAIL_NOTIFICATIONS_TEXT = "メール"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3470
  override val CHALLENGE_EMAIL_UPDATES_TEXT = "メール"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3468
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBHEADER = "チャレンジ更新情報"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3469
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBTEXT = "コミュニティとチャレンジの進捗状況を更新してください！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3466
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBHEADER = "毎日のリマインダー"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3467
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBTEXT = "1月に毎日練習するためのリマインダーを受け取りましょう！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3809
  override val CHALLENGE_FAQ_A1 = "A: チャレンジを完了するには、その月の毎日練習を完了する必要があります。どのDown Dogアプリでも使用できます。練習は完全に完了する必要があります。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3811
  override val CHALLENGE_FAQ_A2 = "A: Down Dogは、アプリのジャーニーページにあるカレンダーを使用してあなたの進捗を追跡します！ 毎日練習してカレンダーの日付が青く表示されると、それがチャレンジの進捗として記録されます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3814
  override val CHALLENGE_FAQ_A3 = "A: 毎日のリマインダーは、前日に練習した時間に基づいて送信されます。ですので、普段より早く練習した場合は、私たちより先に行動しているかもしれません！ ジャーニーページのカレンダーに練習が記録されていれば、それはチャレンジの進捗にカウントされます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3816
  override val CHALLENGE_FAQ_A4 = "A: いいえ。申し訳ありませんが、Down Dogアプリで完了していないプラクティスを履歴に追加することはできません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3818
  override val CHALLENGE_FAQ_A5 = "A: 旅行中でタイムゾーンが変わる場合、チャレンジの連続記録に影響を与える可能性があります。現在、私たちのシステムは、練習を行った時のタイムゾーンに基づいて練習履歴を記録しています。つまり、練習の日付は元のタイムゾーンではなく、現在のタイムゾーンに合わせて記録されます。連続記録を維持するためには、可能な限り元のタイムゾーンに合わせた時間に練習することをお勧めします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3820
  override val CHALLENGE_FAQ_A6 = "A: 勝者は、チャレンジを完了したユーザーのグループからランダムに選ばれます。勝者には、チャレンジ終了時に個別に連絡されます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3808
  override val CHALLENGE_FAQ_Q1 = "Q: 必要条件は何ですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3810
  override val CHALLENGE_FAQ_Q2 = "Q: 進捗はどのように追跡されますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3813
  override val CHALLENGE_FAQ_Q3 = "Q: 毎日の通知に登録していますが、今日は受け取っていません。何か問題がありますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3815
  override val CHALLENGE_FAQ_Q4 = "Q: 他の場所で練習を完了しましたが、それをアプリの履歴に追加できますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3817
  override val CHALLENGE_FAQ_Q5 = "Q: チャレンジ期間中に旅行する予定があります。それは何かに影響しますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3819
  override val CHALLENGE_FAQ_Q6 = "Q: グッズの当選者はどのように選ばれ、連絡されますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3807
  override val CHALLENGE_FAQ_TITLE = "Down Dog チャレンジ FAQ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3465
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TEXT = "通信を受け取らないことを選択したため、Down Dogのチャレンジに関する進捗状況やリマインダーは受け取れません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3471
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TITLE = "本当ですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3303
  override val CHALLENGE_PUSH_NOTIFICATIONS_TEXT = "プッシュ通知"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3317
  override val CHALLENGE_RESUBSCRIBE_TO_EMAILS_ALERT_TEXT = "ご注意ください！以前、Down Dogからのメール通信を受け取らないように設定されていました。チャレンジ内でメール通信を有効にすると、自動的にメール通信を受け取る設定に戻ります。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1218
  override val CHANGE_EMAIL_ANSWER = "1. <b>設定</b>に移動します。モバイルアプリでは右下の三本線から、ウェブでは左側のサイドバーから進めます。\n2. [<b>アカウント</b>]で[<b>Eメール</b>]をタップし、メールアドレスを入力します。\n3. [<b>保存する</b>]をタップします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1208
  override val CHANGE_EMAIL_QUESTION = "登録しているEメールアドレスを変更するにはどうすればよいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=152
  override val CHANGE_LANGUAGE = "言語を変える"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1159
  override val CHANGE_LANGUAGE_ANSWER = "<b>ヨガ、プレナタル、瞑想、HIIT</b>\n\n言語は<b>設定</b>に移動して変更できます（モバイルアプリでは、右下の3つの水平線をタップし、ウェブアプリでは設定は左のサイドバーにあります）。その後、<b>言語</b>をタップしてください！\n\n<b>バレエ</b>\n\n現在、このアプリは英語のみで提供されています。言語を変更した後も、指示は英語で聞こえます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=327
  override val CHANGE_LANGUAGE_NO_INTERNET_MESSAGE = "言語を変更するには、インターネットに接続する必要があります。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1158
  override val CHANGE_LANGUAGE_QUESTION = "インストラクションの言語を変更するにはどうすればよいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1219
  override val CHANGE_PASSWORD_ANSWER = "パスワードはモバイルアプリでもWebアプリでも変更できます。方法は以下の通りです。\n \nモバイルアプリ：\n1.右下の3本の横線をタップして、<b>設定</b>に移動します。\n2. [<b>アカウント</b>]で[<b>パスワード</b>]をタップし、新しいパスワードを[パスワード]および[パスワードを確認する]フィールドに入力します。\n3. [<b>保存する</b>]をタップします。\n \nWebアプリ：\n1.左側のサイドバーにある[<b>設定</b>]に移動します。\n2. [<b>アカウント</b>]で[<b>パスワード</b>]をクリックし、新しいパスワードを[パスワード]および[パスワードを確認する]フィールドに入力します。\n3. [<b>保存する</b>]をクリックします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1209
  override val CHANGE_PASSWORD_QUESTION = "パスワードを変更するにはどうすればよいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1142
  override val CHANGE_PLAYLIST_TYPE_ANSWER = "私たちは多くのカテゴリーの音楽を提供し、常に新しいオプションを追加しています！アプリでは、設定ビューを上にスワイプして<b>音楽</b>をタップすると、音楽のタイプを切り替えることができます。 Webバージョンでは、設定画面をスクロールして<b>音楽</b>オプションをクリックします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1141
  override val CHANGE_PLAYLIST_TYPE_QUESTION = "音楽を変更するにはどうすればよいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=52
  override val CHANGE_VISUAL_TYPE_NO_INTERNET_MESSAGE = "この練習のビジュアルを変更するには、インターネット接続が必要です。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1157
  override val CHANGE_VOICE_ANSWER = "<b>ヨガ、プレナタル、瞑想、HIIT</b>\n\n現在、これらのアプリでは複数の英語を話す声を提供しています。モバイルでは、メイン設定ページを上にスワイプしてから<b>音声</b>をタップすることで、聞く声を変更することができます。ウェブでは、設定をスクロールして<b>音声</b>オプションをクリックします。\n\nまた、これらのアプリではいくつかの非英語を話す声も提供しています。言語を変更するには、<b>設定</b>に移動します（モバイルアプリでは、右下の3つの水平線をタップし、ウェブアプリでは設定が左のサイドバーにあります）その後、<b>言語</b>をタップします！\n\n<b>バレエ</b>\n\n現在は1つの声しかありませんが、将来的には追加の言語と声を追加する予定です。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1156
  override val CHANGE_VOICE_QUESTION = "インストラクションの声を変えるにはどうしたらよいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1441
  override val CHARGED_TWICE = "二回請求されました。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1433
  override fun CHECK_OUT_QUESTION(p0: Any) = "${p0}で質問への回答があるか確認してください"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=482
  override val CLEAR_PRACTICE_HISTORY_CONFIRM_MESSAGE = "練習履歴からすべての練習を削除してもよろしいですか？この操作は元に戻せません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=275
  override val CLOSE = "閉じる"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1180
  override val COMMUNITY_ANSWER = "Facebookには活発な意見交換がされ、協力的な<a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\"> Down Dog Community </a>があります。グループに参加してアドバイスを求めたり、あなたの練習の様子をシェアすることができます！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1172
  override val COMMUNITY_QUESTION = "ヨガの練習について話ができるコミュニティを探しています。質問があるときにサポートしてくれるグループはありますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1394
  override val COMPANIES_FREE_UNTIL_JUNE_1_LONG = "在宅勤務の従業員は、6月1日まで無料でメンバーシップを利用できます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2563
  override val CONFIRM_CANCEL_OFFLINE_DOWNLOAD = "このダウンロードをキャンセルしてもよろしいですか?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2561
  override val CONFIRM_DELETE_OFFLINE_PRACTICE = "このオフライン プラクティスを削除してもよろしいですか?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=428
  override val CONFIRM_PASSWORD = "パスワードを確認する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1
  override val CONNECT_TO_APPLE_HEALTH = "Apple Healthに接続"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=93
  override val CONNECT_TO_GOOGLE_FIT = "Google Fitに接続する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2
  override val CONNECTED_TO_APPLE_HEALTH_MESSAGE = "あなたの練習は自動的にApple Healthに記録されます！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=94
  override val CONNECTED_TO_GOOGLE_FIT_MESSAGE = "あなたの練習は自動的にGoogle Fitに記録されます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1009
  override val CONNECTING_TO_CHROMECAST = "接続しています..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=25
  override val CONNECTION_PROBLEM = "接続問題"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=264
  override val CONTACT = "連絡をする"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1421
  override val CONTACT_APPLE_FOR_REFUND = "返金を希望される場合はAppleサポートに連絡し、返金で問題ないことを伝えてください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=265
  override val CONTINUE = "続ける"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=437
  override val CORPORATE_MEMBERSHIP = "法人会員"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=616
  override val COUNTDOWN_TIMER = "残り時間の表示"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2550
  override val CREATE_OFFLINE_PRACTICE = "オフライン練習を作成する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2562
  override val CREATE_OFFLINE_PRACTICE_EXPLANATION = "現在の設定で練習を作成してダウンロードしますか?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1604
  override val CUSTOM = "カスタム"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=266
  override val DELETE = "削除"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=399
  override val DELETE_ACCOUNT = "アカウントを削除する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=487
  override val DELETE_ACCOUNT_AND_STOP_PAYMENTS_CONFIRM_MESSAGE = "すべてのDown Dogアプリでアカウントが完全に削除され、サブスクリプションが自動的にキャンセルされます。続けますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1220
  override val DELETE_ACCOUNT_ANSWER = "退会する場合は、モバイルアプリまたはWebアプリでアカウントを削除できます。一度アカウントを削除すると復元できなくなり、履歴と保存された練習が失われますのでご注意ください。\n \n1. <b>設定</b>に移動します。モバイルアプリでは右下の3本線をタップ、ウェブでは左側のサイドバーから進めます。\n2. [<b>設定</b>]で、[<b>私のデータ</b>]までスクロールし、[<b>アカウントを削除する</b>]をタップします。\n3. ポップアップが表示されたら、[<b> OK </b>]をタップします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=485
  override val DELETE_ACCOUNT_CONFIRM_MESSAGE = "アカウントを削除してもよろしいですか？この操作は元に戻せません。アカウントは Down Dog の全てのアプリから永久に削除されます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1210
  override val DELETE_ACCOUNT_QUESTION = "アカウントを削除するにはどうすればよいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1556
  override val DELETE_ACCOUNT_RECONFIRM_MESSAGE = "Down Dogアプリの全てのアカウントを完全に削除しようとしています。この操作は元に戻せません。続けますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=486
  override val DELETE_ACCOUNT_WITHOUT_STOPPING_PAYMENTS_CONFIRM_MESSAGE = "すべてのDown Dogアプリでアカウントが完全に削除されます。請求はサブスクリプションをキャンセルするまで行われます。続けますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=467
  override val DELETE_HISTORY = "練習履歴を消去する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2565
  override val DELETE_OFFLINE_PRACTICE = "オフライン練習を削除"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1351
  override val DEVICE_LIMIT_ANSWER = "はい！登録時と同じメールアドレスでログインしてください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1306
  override val DEVICE_LIMIT_QUESTION = "サブスクリプションではすべてのデバイス（ラップトップ、電話、タブレットなど）からワークアウトにアクセスできますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1501
  override val DIDNT_PURCHASE_SUBSCRIPTION = "サブスクリプションを購入していません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3946
  override val DISLIKE = "嫌い"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1502
  override val DONT_SEE_SUBSCRIPTION = "サブスクリプションが表示されません"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=629
  override val DOWNLOAD = "ダウンロード"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2557
  override val DOWNLOAD_EXPLANATION = "ダウンロードが完了すると、オフライン プラクティス ページでこのプラクティスを見つけることができます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2559
  override val DOWNLOAD_PRACTICE = "ダウンロード練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2556
  override val DOWNLOAD_STARTED = "ダウンロード開始"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2555
  override fun DOWNLOADING_VIDEO_PROGRESS(p0: Any) = "ダウンロード中... ${p0}%"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3947
  override val EDIT = "編集"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=491
  override val EDIT_EMAIL = "Eメールを編集"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=628
  override val EDIT_NAME = "名前を編集"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=492
  override val EDIT_PASSWORD = "パスワードを編集"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=462
  override val EMAIL = "Eメール"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=137
  override val EMAIL_AND_PASSWORD = "メールアドレスとパスワード"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=197
  override val ENGLISH_POSE_NAMES = "英語のポーズ名"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3370
  override fun ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_INSTRUCTIONS(p0: Any) = "1. 設定アプリを開いてください。\n\n2. 通知に移動してください。\n\n3. ${p0}アプリを探し、<b>通知が有効になっていること</b>を確認してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3304
  override val ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_PROMPT = "モバイルデバイスでDown Dogのプッシュ通知が有効になっていることを確認してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=146
  override val ENTER_CODE = "コードを入力する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=138
  override val ENTER_EMAIL_ADDRESS = "メールアドレスを入力してください"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=139
  override val ENTER_PASSWORD = "パスワードを入力する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2170
  override val EQUIPMENT = "機器"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=88
  override val ERROR_CONNECTING_TO_APPLE_HEALTH_MESSAGE = "ヘルスケア App 接続中にエラーが発生しました"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=56
  override val ERROR_CONNECTING_TO_GOOGLE_FIT_MESSAGE = "Google Fitに接続中にエラーが発生しました。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=57
  override val ERROR_OCCURRED_MESSAGE = "エラーが発生しました。お問い合わせください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1198
  override val EXCLUDE_POSES_ANSWER = "<b> HIIT </b>\n\nはい！ [練習]で、[<b>ミックス</b>]をタップします。そこから、各体の部分の左側にある+をタップするとエクササイズが表示されます。練習から除外したい特定の練習をタップしてください。\n\n<b>ヨガ、マタニティヨガ、バレエ</b>\n\n現在この機能はありませんが、今後含まれる予定です。今のところ、モバイルアプリでは、表示されたときに<b>左にスワイプ</b>することで、避けたいポーズをスキップできます。ウェブアプリでは、画面の左下にある<b>進む矢印</b>をクリックします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1187
  override val EXCLUDE_POSES_QUESTION = "練習から特定のポーズを除くことはできますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1262
  override val EXERCISE_ADVICE = "練習のアドバイス"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1602
  override val EXERCISE_LIST = "ポーズリスト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3254
  override val EXERCISE_NAMES = "エクササイズ名"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=267
  override val EXIT = "終了する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=268
  override val EXIT_PRACTICE = "練習を終了する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=156
  override val EXIT_PRACTICE_MESSAGE = "今の練習を終了しますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2720
  override val EXPLICIT_LYRICS = "露骨な歌詞"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=280
  override val FACEBOOK = "Facebook"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=58
  override val FACEBOOK_AUTHENTICATION_FAILURE_MESSAGE = "Facebookの認証に失敗しました。後でもう一度お試しください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=147
  override val FACEBOOK_COMMUNITY = "Facebookコミュニティ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2552
  override val FAILED_PRACTICE_DOWNLOAD = "練習のダウンロードに失敗しました"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2568
  override val FAILED_PRACTICE_DOWNLOAD_EXPLANATION = "このプラクティスのダウンロード中に問題が発生しました。もう一度やり直してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1308
  override val FAMILY_SHARING_ANSWER = "残念ながら、Appleファミリー共有には対応しておりません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1307
  override val FAMILY_SHARING_QUESTION = "サブスクリプションを家族と共有できますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1434
  override val FAQ_PAGE = "FAQページ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=269
  override val FAVORITE = "お気に入りに追加"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=278
  override val FAVORITES = "お気に入り"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1261
  override val FEATURE_REQUEST = "機能のリクエスト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2153
  override val FEEDBACK_OPTIONAL = "フィードバック（オプション）"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1274
  override val FEEDBACK_SUBMITTED_TEXT = "ご記入いただきありがとうございます！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2553
  override val FETCHING_PRACTICE = "練習を作成中..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1417
  override val FITBIT_ANSWER = "番号"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1416
  override val FITBIT_QUESTION = "アプリはFitBitに接続しますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3957
  override val FOR_YOU = "あなたのために"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=140
  override val FORGOT_PASSWORD = "パスワードをお忘れですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=461
  override val FORGOT_PASSWORD_NEEDS_EMAIL = "Eメールアドレスを入力してパスワードをリセットして下さい。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1291
  override val FREE_FOR_HEALTHCARE_WORKERS = "医療従事者は無料"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1110
  override val FREE_FOR_SCHOOLS = "学校を対象に無料"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1395
  override val GET_COMPANIES_MEMBERSHIP = "無料の企業メンバーシップを取得する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1393
  override val GET_HEALTHCARE_MEMBERSHIP = "医療関係者メンバーシップを取得する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1392
  override val GET_STUDENT_MEMBERSHIP = "学生会員になる"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1463
  override val GIFT_ANSWER = "いいえ、現在提供しておりません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3823
  override val GIFT_INSTRUCTIONS_CONTENT_1 = "Down Dogのギフト（またはギフト！）を購入する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3824
  override val GIFT_INSTRUCTIONS_CONTENT_2 = "印刷して友人や家族に送ることができるギフト証明書を受け取る"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3825
  override val GIFT_INSTRUCTIONS_CONTENT_3 = "受取人は、準備ができたらいつでもアクセスを開始するために、証明書にあるQRコードを使用できます！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3780
  override val GIFT_INSTRUCTIONS_TITLE = "仕組み:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1462
  override val GIFT_QUESTION = "サブスクリプションを他の人にプレゼントすることはできますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1440
  override val GO_TO_APPLE_SUPPORT = "Appleサポートに移動"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1519
  override val GOAL_STREAK_CAPITALIZED = "達成した連続練習日数"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1514
  override val GOAL_STREAK_NOT_CAPITALIZED = "達成した連続練習日数"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=281
  override val GOOGLE = "Google"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=60
  override val GOOGLE_AUTHENTICATION_FAILURE_MESSAGE = "Googleの認証に失敗しました。後でもう一度お試しください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1401
  override val GOOGLE_FIT_ANSWER = "残念ながら、私たちはもうGoogle Fitをサポートしていません。\n\nGoogleがいくつかの変更を行ったため、Google Fitを私たちの提供するサービスに統合し続けることが非常に困難になりました。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1400
  override val GOOGLE_FIT_QUESTION = "アプリはGoogle Fitに接続しますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1495
  override val GUIDED_MEDITATION_AND_BREATHING_ANSWER = "<b>ヨガ：</b>\n\n<em>ヨガ・ニドラを試してみてください</em>\n\n<b>ヨガ・ニドラ</b>は、ヨガアプリの練習<b>タイプ</b>の下にあります。\n\n注：ヨガ・ニドラは<b>音声のみ</b>で、ビデオはありません。\n\n多くの人々は、アプリ内の<b>音楽</b>を自然の音、アンビエント、脳波、ピアノとストリングスに設定することを楽しんでいます。いくつか試して、あなたが好きなものを見つけてみてください！\n\nヨガ・ニドラが初めての方は、<b>指導タイプ</b>を<b>完全な説明</b>または<b>デフォルト</b>に設定して聞いてみることをお勧めします。\n\nまた、ヨガ・ニドラを使って眠りにつくこともできます。ヨガ・ニドラを練習タイプとして選択した後、<b>ブースト</b>に行き、<b>スリープ</b>をタップしてください！\n\n\n<b>プレナタルヨガ：</b>\n\n<b>ブースト</b>を<b>呼吸</b>に設定してください！これにより、練習の始めにいくつかの呼吸エクササイズが行われ、終わりにはガイド付き瞑想が行われます！\n\n\n<b>瞑想：</b>\n\n私たちは瞑想と呼吸に専念したアプリ全体を持っています！<a href='https://meditation.downdogapp.com/download'>瞑想</a>でチェックしてみてください！\n\n瞑想が初めての方は、最も指導を受けるために、設定ビューを上にスワイプして<b>ガイダンス量</b>を<b>最大</b>に設定し、<b>最長の沈黙</b>を短い時間、例えば30秒や1分に設定してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1494
  override val GUIDED_MEDITATION_AND_BREATHING_QUESTION = "より多くの呼吸法と誘導瞑想を練習するにはどうしたら良いですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=95
  override val HEALTH_DISCLAIMER_AND_WARNING = "健康に関する免責事項と警告"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=97
  override val HEALTH_WAIVER_TEXT = "* Yoga Buddhi Co.は、教育目的でのみに設計された健康とフィットネスの情報を提供しています。Yoga Buddhi Co.が作成したアプリケーション（デスクトップ、モバイル、デバイスのアプリケーション、ウェブサイト、ブログ、およびYoga Buddhi Co.またはDown Dog アプリが管理するソーシャルメディアページを含みますが、これらに限定されません）の情報に、専門的な医療アドバイス、診断、または治療の代わりとして依存しないでください。私たちは、どのアプリケーションにおいても、コンテンツの正確性、完全性、または有用性において一切保証いたしません。このアプリケーションまたはYoga Buddhi Co.によって作成された他のアプリケーションで提供される情報の使用は、ご自身の責任で行ってください。Yoga Buddhi Co.は、このアプリケーションや、Yoga Buddhi Co.が作成した他のアプリケーションによって、直接的または間接的に発生する可能性のある損害、状況、状態または怪我に対して一切の責任を負いません。ヨガの練習は怪我のリスクを伴います。妊娠中または18歳未満の場合、適切な監督なしのヨガの練習は推奨しません。 Yoga Buddhi Co.によって作成されたアプリケーションを使用することにより、あなたは自身の健康と、あなた、もしくは胎児の健康に影響を与える可能性のある怪我や事故に全ての責任を負います。フィットネスプログラムを開始する前、または健康について懸念や質問がある場合は、医師または医療専門家に相談してください。医師または他の医療専門家に必ず相談してください。医師または医療関係者からの許可がない場合はフィットネスプログラムを開始しないでください。練習中に失神、めまい、痛み、または息切れを感じた場合はすぐに中断し、直ちに医師の診察を受けてください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1391
  override val HEALTHCARE_FREE_UNTIL_JANUARY_1_LONG = "医療提供者は2022年6月1日まで無料会員になる資格があります！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1459
  override val HEALTHCARE_MEMBERSHIPS = "医療関係者会員"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1753
  override val HERE_ARE_YOUR_SETTINGS = "これがあなたの設定です！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=785
  override val HIIT = "HIIT"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=758
  override val HIIT_GOOGLE_FIT_DESCRIPTION = "インターバルトレーニングワークアウト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=282
  override val HISTORY = "履歴"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1517
  override fun HOURS_SHORT(p0: Any) = "${p0}時間"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1176
  override val HOW_MANY_INTRO_LESSONS_ANSWER = "イントロには全部で9つのレッスンがあります！\n \n[<b>タイプ</b>]をタップすると、ヴィンヤサ、ハタ、およびリストラティブの3つのカテゴリが表示されます。\n \n<b>タイプ</b>を選択したら、数字（<b> 1、2、または3 </b>）をタップして、対応するレッスンを行います。番号が付けられたレッスンは、次に進むための準備となるように作られているため、1から始めることをお勧めします。円の背景が白い場合は、そのタイプのレッスンが選択されています。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1168
  override val HOW_MANY_INTRO_LESSONS_QUESTION = "入門レッスンはいくつありますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1475
  override val HOW_TO_CANCEL_ANSWER = "<b>サブスクリプションを管理またはキャンセルする方法</b>\n\n<em>ウェブでサブスクリプションを購入した場合</ em>：\n\n1. [<b>設定</b>]に移動します。モバイルでは、画面の右下にある3本の水平線をタップします。ウェブでは、設定は左側のサイドバーにあります。\n2. [<b>設定</b>]で、[<b>購読</b>]をタップします。\n3.次に、自動更新をオフにするなど、サブスクリプションをキャンセルまたは変更する方法などの詳細が表示されます。\n\n<em>モバイルアプリからサブスクリプションを購入した場合</ em>：\n\nサブスクリプションは、<a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\"> Apple App Store </a>または<a href = \"https ：//support.google.com/googleplay/answer/7018481？co = GENIE.Platform％3DAndroid＆hl = en \"target =\" _ blank \"> Google Playストア</a>で管理できます。\n\n<b>サブスクリプションについて</b>\n\n当社のWebサイト、Apple、またはGoogleを通じてメンバーシップを明示的に購入しない限り、サブスクリプションの請求をされることはありません。サブスクリプションは、サブスクリプションの購入時に使用したメールアドレスで確認できます。アカウントにサブスクリプションが表示されない場合は、現在ログインしているメールアドレスからのサブスクリプションがないことを意味し、サブスクリプションが別のメールアドレスを使って行われている可能性があります。その場合は、ログアウトしてから、そのメールアドレスで再度ログインして、サブスクリプションを確認する必要してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1476
  override val HOW_TO_CANCEL_QUESTION = "サブスクリプションをキャンセルしたいのですが。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=99
  override val I_AGREE = "同意する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1352
  override val I_HAVE_A_DIFFERENT_QUESTION = "別の質問があります"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1264
  override val I_HAVE_A_QUESTION_ABOUT = "以下について質問があります。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1383
  override val I_STILL_NEED_HELP = "まだ解決しません"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1387
  override val I_WANT_A_REFUND = "払い戻しを希望します"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3292
  override val INCLUDE_POSES_ANSWER = "<b>ヨガ</b> \n\n私たちの「好きなポーズ」と「除外するポーズ」の機能を使うと、特定のポーズを「好き」に設定することで、そのポーズが将来の練習で出現する確率を上げることができます。全設定から、<b>練習</b>の下にある<b>ポーズを見る</b>をタップします。ここから、練習でより多く見たいポーズを「好き」に設定できます。\n\n<b>ポーズを見る</b>からは、ポーズを「嫌い」に設定して、それらを将来の練習から除外することもできます。\n\n「好きなポーズ」と「除外するポーズ」の機能は、新しい練習タイプのビンヤサ、リストラティブ、イン、ジェントル、ハタにのみ利用可能であることに注意してください。古い練習タイプではこの機能はサポートされていません。\n\nまた、ポーズを好き/嫌いに設定すると、バラエティに影響を与えることにも注意してください。\n\n\n<b>HIIT</b> \n\nはい！練習の下にある<b>ミックス</b>をタップします。そこから、各部位の左側にある+をタップすると、エクササイズのリストが表示されます。練習から除外したい特定のエクササイズをタップします。\n\n\n<b>妊娠中、バレエ</b>\n\n現在、この機能はありませんが、確かにリストに入っています！現在は、モバイルアプリでは、好きでないポーズが出てきたときに左にスワイプしてスキップすることができます。ウェブアプリでは、画面の左下にある矢印をクリックします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3291
  override val INCLUDE_POSES_QUESTION = "私の練習に特定のポーズを含めることは可能ですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=155
  override val INSTAGRAM = "Instagram"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=61
  override val INVALID_EMAIL_MESSAGE = "有効なメールアドレスではないようです。もう一度お試しください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=161
  override val KEEP_TIMELINE_VISIBLE = "タイムラインが見えるようにする"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=250
  override val LANGUAGE = "言語"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1426
  override val LATEST_PAYMENT = "最新のお支払い："
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1396
  override val LEARN_MORE = "もっと詳しく"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=168
  override val LENGTH = "長さ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=254
  override val LESS = "少なく"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1179
  override val LEVEL_ANSWER = "人によって異なるため、1つ上のレベルを試してみるとよいでしょう。レベルを下げたい日もあれば、何か新しいことに挑戦したいと感じる日もあるでしょう。最も大切なのは、体からのフィードバックを感じ、急がずゆっくりと動くことです。\n\nアプリの<a><b>設定</b>ページからアクセスできる<a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\"> Facebookコミュニティ</a>は、アプリを使用している他の人々からアドバイスを受けられる、役立つ情報源です！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1171
  override val LEVEL_QUESTION = "練習レベルはいつ上げたら良いでしょうか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=344
  override val LIFETIME = "永久"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1465
  override val LIFETIME_ANSWER = "いいえ、現在提供しておりません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1464
  override val LIFETIME_QUESTION = "永久サブスクリプションを購入できますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3945
  override val LIKE = "いいね"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3047
  override val LIKE_OR_DISLIKE_EXPLANATION = "将来の練習を改善するために、ポーズを「好き」または「嫌い」で評価してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3199
  override fun LIKED_DISLIKED_COUNT(p0: Any, p1: Any) = "${p0} 好き、${p1} 嫌い"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2030
  override val LOCK_SCREEN_MEDIA_CONTROLS = " ロック画面のメディアコントロール"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1729
  override val LOG_IN = "ログインする"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1407
  override fun LOGGED_IN_AS(p0: Any) = "${p0}としてログインしています。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=310
  override val LOGIN_ERROR = "ログインエラー"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=141
  override val LOGOUT = "ログアウト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=62
  override val LOGOUT_NO_INTERNET_MESSAGE = "インターネットに接続されていないようです。アカウントを切り替えるには、再接続してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1456
  override fun LOOK_SCHOOL_PAGE(p0: Any) = "学生または教師の方は、${p0}をご覧ください"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1227
  override val LOWER_VIDEO_QUALITY_ANSWER = "異なる映像タイプに切り替えるには、[<b>その他</b>]をタップしてから、[<b>映像クオリティ</b>]をタップします。高品質および低品質の画像オプションが表示されます。この設定ができるのはヨガアプリのみです。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1217
  override val LOWER_VIDEO_QUALITY_QUESTION = "動画がスマートフォンの容量を消費しすぎています。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2158
  override val MAKE_SURE_TO_VOTE_FOR_EVERY_OPTION = "すべてのオプションに投票してください！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1486
  override val MANAGE_EMAIL_PREFERENCES_ANSWER = "あまり多くのメールを送信しないようにしていますが、皆さまに特別なセールや新機能を知らせるための手段であることをご了承ください。\n\n[<b>設定</b>]に移動し、[<b>プロモーションメールを受け取る</b>]までスクロールしてオンとオフを切り替えることで、メールの購読または購読解除をすることができます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1488
  override val MANAGE_EMAIL_PREFERENCES_QUESTION = "メール設定を管理するにはどうすればよいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1161
  override val MAXIMUM_VERBOSITY_ANSWER = "<b>ヨガとマタニティヨガ：</b>\n\n設定ビューを上にスワイプしてから<b>インストラクション</b>をタップすると、インストラクションを増やすことができます。 <b>全ての説明</b>をタップしてインストラクションを最も多く受けます。\n\n<b>瞑想：</b>\n\n最も多くインストラクションを受けるには、<b>誘導の量</b>を<b>最も多く</b>に設定し、<b>最も長い沈黙時間</b>を30秒や1分などの短い時間に設定します。\n\n<b> HIITとバレエ：</b>\n現在、HIITとバレエではインストラクションの量を変更する機能を提供していません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1160
  override val MAXIMUM_VERBOSITY_QUESTION = "ポーズをする時にできるだけ沢山インストラクションを聞きたいです。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1661
  override val MEDITATION = "瞑想"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1672
  override val MEDITATION_GOOGLE_FIT_DESCRIPTION = "瞑想の練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1431
  override val MEMBERSHIP_DELAYED_START_ANSWER = "いいえ。購入するとすぐにサブスクリプションが開始されます。\n\n無料試用期間中の場合は、試用期間が終了するまで待つことをお勧めしますが、特別セールを実施している場合は、最もお得な価格を逃してしまう可能性があります（決断に迷うかもしれませんが！）\n\n特別セールを行っているかいないかに関わらず、当社のWebサイトでは通常最もお得な価格を提供しています。購入を決めたら<a href=\"/purchase\">downdogapp.com/purchase</a>から購入をしてください！\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1430
  override val MEMBERSHIP_DELAYED_START_QUESTION = "サブスクリプションの開始日を遅らせることはできますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=148
  override val MENU = "メニュー"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1163
  override val MINIMUM_VERBOSITY_ANSWER = "<b>ヨガとプレナタルヨガ：</b>\n\n設定ビューを上にスワイプして、<b>指示</b>をタップすることで、話す量を減らすことができます。我々が提供する最少の指示を受けるには、<b>最少</b>をタップしてください。\n\n<b>瞑想：</b>\n\n我々が提供する最少の指示を受けるには、設定ビューを上にスワイプし、<b>ガイダンス量</b>を<b>最少</b>に設定し、<b>最長の沈黙</b>を5分以上などの長い時間に設定してください！\n\n<b>HIITとバレエ：</b>\n現在、HIITとバレエの話す量を変更する機能は提供しておりません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1162
  override val MINIMUM_VERBOSITY_QUESTION = "できるだけインストラクションを少なくして聞きたいです。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=309
  override fun MINUTES(p0: Any) = "${p0}分"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1254
  override fun MINUTES_SHORT(p0: Any) = "${p0}分"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1610
  override val MINUTES_WITHOUT_NUMBER = "分"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1554
  override val MIRROR_VIDEO = "映像を左右反転する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3
  override val MISSING_APPLE_HEALTH_PERMISSIONS_MESSAGE = "Down DogがヘルスケアAppのソースとして追加されました。ただし、練習を開始するには、ヘルスケアApp内からDown DogのWorkouts権限を有効にする必要があります。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1583
  override val MIX = "ミックス"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1510
  override val MONDAY = "月曜"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=519
  override val MONTH = "月"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=377
  override val MONTHLY = "毎月"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1290
  override val MONTHLY_CAPITALIZED = "毎月"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1511
  override val MONTHLY_PRACTICES = "今月の練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1516
  override fun MONTHLY_TIME(p0: Any) = "${p0}の時間"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1513
  override val MONTHLY_TIME_PRACTICED = "一か月の練習時間"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1482
  override val MONTHLY_TO_YEARLY_ANSWER = "すでに月単位のサブスクリプションを購入していて、代わりに年間のサブスクリプションを希望する場合は、現在の購入方法に応じた手順が必要になります。\n\n<em> <b>ウェブサイト</b>または<b> Google Play </b>から購入した場合</ em>：\n\n現在のサブスクリプションをWeb経由で購入した場合は、[<b>設定</b>]、[<b>サブスクリプション</b>]の順に移動して、現在のサブスクリプションをキャンセルしてください。 Google Playから購入した場合は、<a href = \"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=ja\" target = \"_ blank\"> Google Playストア</a>から現在のサブスクリプションをキャンセルできます。現在のサブスクリプションをキャンセルした後、<a href=\"/purchase\">ウェブサイトから新しいサブスクリプションを購入</a>できます。\n\nキャンセルして再購入する場合、一部払い戻しはできませんのでご注意ください。一部の状況では、現在の購入の払い戻しの対象となる場合があります。<a href=\"/support\">サポート</a>で[払い戻しを希望します]をクリックすると、払い戻しの対象になるかを確認できます。払い戻しの対象であり、<a href=\"/support\">サポート</a>の「払い戻しを希望します」からのリクエストで払い戻しの対象と確認された場合、現在のサブスクリプションは自動的にキャンセルされます。その後、<a href=\"/purchase\">ウェブサイトから新しいサブスクリプションを購入</a>できます。\n\n<em> <b> Apple </b>からサブスクリプションを購入した場合</ em>：\n\n<a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\"> Apple App Storeを通じて </a>サブスクリプションをキャンセルする必要があります。当社ではApple経由の購入の払い戻しリクエストには対応できませんのでご了承ください。 Appleを通じて現在のサブスクリプションをキャンセルした後、<a href=\"/purchase\">当社のWebサイトから新しいサブスクリプションを購入</a>できます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1481
  override val MONTHLY_TO_YEARLY_QUESTION = "月額プランを購入しましたが、年額プランに切り替えたいです。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=276
  override val MORE = "その他"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=182
  override val MUSIC = "音楽"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1140
  override val MUSIC_VOLUME_VS_VOICE_ANSWER = "練習が始まった後、画面をタップして練習を一時停止すると、<b>音楽/声量 ミキシングスライダー</b>を使って音楽と声の音量を調整できます。\n\n好みの音楽と声量の割合を設定したら、デバイス上で全体の音量を調整できます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1139
  override val MUSIC_VOLUME_VS_VOICE_QUESTION = "インストラクターの声が聞こえません。音量調節はどこで出来ますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=400
  override val MY_DATA = "私のデータ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=429
  override val NEED_INTERNET_FOR_SONG_PREVIEW_MESSAGE = "この曲のプレビューを再生するには、インターネットに接続をしてください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3587
  override val NEW_PASSWORD = "新しいパスワード"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=9
  override val NEXT = "次へ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=403
  override val NEXT_PAYMENT = "次のお支払い"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=483
  override fun NEXT_PAYMENT_SUBTEXT(p0: Any) = "次の支払い：${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1499
  override val NIDRA_AUDIO_ONLY_ANSWER = "ヨガ二ドラは<b>音声のみ</b>です - 映像はありません！\n\nヨガニドラは深くリラックスして行う誘導瞑想です。練習の<b>タイプ</b>で一番下までスクロールして選んでください。<b>音楽</b>をネイチャーサウンド、アンビエント、脳波、またはピアノと弦楽器に設定している人が多いです。いくつか試してお気に入りを見つけましょう！\n\nヨガ二ドラを初めてする場合は、<b>インストラクション</b>を<b>全ての説明</b>または<b>標準</b>に設定して聞くことをお勧めします。眠るためにヨガ二ドラを使っても良いでしょう。\n\n練習タイプでヨガ二ドラを選択したら、<b>ブースト</b>に移動して<b>睡眠</b>をタップします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1498
  override val NIDRA_AUDIO_ONLY_QUESTION = "ヨガニドラの練習で画像が表示されません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1472
  override val NO_EXCHANGE_FEES_ANSWER = "弊社からは両替手数料を請求しませんが、ご利用の銀行から請求される場合があります。確認をしてください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1471
  override val NO_EXCHANGE_FEES_QUESTION = "為替手数料はかかりますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=160
  override val NO_FACEBOOK_EMAIL_MESSAGE = "Facebookでログインするには、あなたのメールアドレスにアクセスできるようにしてください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=162
  override val NO_HISTORY_TEXT = "まだ練習を完了していないようです。スワイプしてホーム画面に戻り、最初の練習を始めましょう！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=63
  override val NO_INTERNET_MESSAGE = "サーバーとの通信に問題が発生しました。インターネット接続を確認して、もう一度お試しください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1497
  override val NO_MUSIC_OFFLINE_ANSWER = "ライセンスの制限により、オフラインでの保存されたお気に入りの練習では音楽が流れません。\n\n自分の好きな音楽を再生したい場合は、デバイスの他のアプリから再生できます。ただし、携帯電話やタブレットの設定で音声ボリュームが最大になっていると、Spotify / iTunesなどからの音量が聞こえにくいかもしれません。\n\nこのような場合は、外部スピーカーを使用して音楽を再生するか、ノートパソコンまたはデスクトップで音楽をオフにしてウェブバージョン<a href=\"/web\"> downdogapp.com/web </a>を使用することをお勧めします。\n\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1496
  override val NO_MUSIC_OFFLINE_QUESTION = "オフラインで使っていますが、保存したお気に入りの練習で音楽が流れません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2551
  override val NO_OFFLINE_PRACTICES = "プラクティスをまだダウンロードしていません。履歴からプラクティスをダウンロードするか、ここで新しいプラクティスを作成できます!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1478
  override val NO_PARTIAL_REFUND_ANSWER = "残念ながら、部分的または日割りの払い戻しのリクエストには対応できません。\n\n既にサブスクリプションを購入してて、別のサブスクリプションを購入する場合は、現在の購入方法に応じて、いくつかの手続きをする必要があります。\n\n<em> <b>ウェブサイト</b>または<b> Google Play </b>から購入した場合</ em>：\n\n現在のサブスクリプションをWeb経由で購入した場合は、[<b>設定</b>]、[<b>購読</b>]の順に移動して、現在のサブスクリプションをキャンセルしてください。 Google Playから購入した場合は、<a href = \"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=ja\" target = \"_ blank\">Google Playストア</a>から現在のサブスクリプションをキャンセルできます 。現在のサブスクリプションをキャンセルした後、<a href=\"/purchase\">ウェブサイトから新しいサブスクリプションを購入</a>できます。\n\nキャンセルして再購入をする場合、一部の払い戻しはできませんのでご注意ください。場合によっては、現在の購入の払い戻しの対象となる場合があります。<a href=\"/support\">サポート</a>で[払い戻しを希望します]をクリックして、払い戻しの対象かどうかを確認できます。払い戻しの対象であり、<a href=\"/support\">サポート</a>の「払い戻しを希望します」で払い戻しが可能であることの確認が出来た場合、現在のサブスクリプションは自動的にキャンセルされます。その後、<a href=\"/purchase\">ウェブサイトから新しいサブスクリプションを購入</a>できます。\n\n<em> <b> Apple </b>を通じてサブスクリプションを購入した場合</ em>：\n\n<a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\"> Apple App Store </a>からサブスクリプションをキャンセルする必要があります。アップル経由の購入の払い戻しリクエストには対応できませんのでご了承ください。 Appleを通じて現在のサブスクリプションをキャンセルした後、<a href=\"/purchase\">当社のWebサイトから新しいサブスクリプションを購入</a>できます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1477
  override val NO_PARTIAL_REFUND_QUESTION = "一部払い戻しを受けることはできますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=283
  override val NO_PAST_PURCHASES = "過去の購入はありません"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=163
  override val NO_PAST_PURCHASES_MESSAGE = "これまでに購入をされたことがないようです。これが間違いだと思われる場合はお問い合わせください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1454
  override val NO_REFUND_PRACTICED = "購入後に練習を完了しているため、この支払いは返金されません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1455
  override fun NO_REFUND_TIME(p0: Any) = "この支払いは${p0}日前に行われたため、払い戻しできません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=164
  override val NO_SAVED_PRACTICES_TEXT = "お気に入りの練習を保存して後で再生しましょう"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1224
  override val NO_SOUND_ANSWER = "以下は、アプリから音を出すためのいくつかの方法です。\n\n• デバイス自体がミュートされていないことを確認しましたか？別のアプリで音楽やオーディオを再生して確認できます。\n• アプリ内ボリュームがオンになっていることを確認しましたか？練習を開始したら、練習を一時停止して、画面下部のスライダーを調整して音楽と声の音量のバランスを調整できます。音楽と音声の両方を聞くには、中央付近で調整してください。\n• アプリを閉じて、もう一度開いてみましたか？\n• アプリをアンインストールして再インストールしてみましたか？\n• Web版のDown Dog（<a href=\"https://www.downdogapp.com/web\" target=\"_blank\"> https://www.downdogapp.com/web </a>）を使っても同じ問題がありますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1214
  override val NO_SOUND_QUESTION = "音が聞こえません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=10
  override val NO_STRING = "いいえ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1388
  override val NO_SUBSCRIPTIONS_SUPPORT_MESSAGE = "アカウントに有効なサブスクリプションはありません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=284
  override val NONE = "なし"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1483
  override val NOT_FREE_ANSWER = "2018年9月に、すべての機能に完全にアクセスできる短期間の無料トライアルを提供し、その後はサブスクリプションが必要となる新しい価格モデルに移行しました。この価格モデルは、すべてのアプリに適用されます。\n\n<b>購入方法</b>\n\n<a href=\"/purchase\">当社のウェブサイトでの購入</a>が通常、最もお得な価格を提供します！ウェブサイトでは、<b>クレジットカード</b>または<b>PayPal</b>で購入できます。ウェブサイトでの購入は、AppleやGoogleを通じてアプリ内で購入した場合と同様に、すべてのアプリのすべての機能にアクセスできます。\n\nAppleまたはGoogleを通じてアプリ内で購入することもできます。ただし、AppleとGoogleは手数料を請求するため、アプリ内の価格は通常、当社のウェブサイトよりも高くなりますのでご注意ください。\n\nアメリカ国外での購入については、当社は為替手数料を請求しませんが、銀行が請求する可能性があるため、必ず銀行に確認してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1468
  override val NOT_FREE_QUESTION = "アプリは無料だと思いましたが、サブスクリプションの購入を求められるのはなぜですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=285
  override val OK = "OK"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1686
  override fun ONLY_MIX_GROUP(p0: Any) = "${p0}のみ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=243
  override val OPEN_IN_AMAZON = "Amazonで開く"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=216
  override val OPEN_IN_ITUNES = "iTunesで開く"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=32
  override val OPEN_IN_SPOTIFY = "Spotifyで開く"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1257
  override fun OPEN_IN_X(p0: Any) = "${p0}で開く"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3948
  override val OPEN_LINK = "リンクを開く"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2149
  override fun OPTION_X_OF_Y(p0: Any, p1: Any) = "${p1}のオプション${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=142
  override val OR = "または"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1111
  override val OTHER = "その他"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1059
  override val OTHER_APPS = "他のアプリ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=194
  override val PACE = "ペース"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=463
  override val PASSWORD = "パスワード"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=68
  override val PASSWORD_LENGTH_MESSAGE = "パスワードは4文字以上にする必要があります。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=445
  override val PASSWORDS_MUST_MATCH = "パスワードが一致する必要があります"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3944
  override val PAUSE = "一時停止"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=339
  override val PAY_WITH = "でお支払い"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=349
  override val PAY_WITH_PAYPAL = "PayPalでお支払い"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=480
  override val PAYPAL = "PayPal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=347
  override val PAYPAL_AUTHORIZATION_ERROR_MESSAGE = "PayPalの購入を承認する際にエラーが発生しました。数分後にもう一度お試しいただくか、カスタマーサポートにご連絡ください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1419
  override val PAYMENT_ALREADY_REFUNDED = "この支払いはすでに返金されています。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=165
  override val PAYMENT_CONFIRMED_MESSAGE = "お支払いが確認されました！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1474
  override val PAYMENT_METHODS_ANSWER = "サブスクリプションを購入する方法は次のとおりです。\n\n1) <b>クレジット カード</b>または<b>PayPal</b>を使用して、当社のウェブサイトから購入できます。\n\n当社のウェブサイトから購入すると、Apple または Google からアプリ内購入した場合と同様に、すべてのアプリのすべてにアクセスできます。 Apple/Google の手数料がかからないため、通常、当社のウェブサイトの価格が最安値です。\n\n2) Apple または Google からアプリ内で購入できます。\n\nApple と Google は手数料を請求するため、アプリ内価格は通常、当社の Web サイトよりも高くなります。\n\n米国外での購入の場合、交換手数料は請求されませんが、銀行によっては請求される場合があるため、必ず銀行に確認してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1473
  override val PAYMENT_METHODS_QUESTION = "どのような支払い方法がありますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=465
  override val PAYMENT_PLAN = "プラン"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=317
  override val PER_MONTH = "1か月あたり"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=318
  override val PER_YEAR = "1年あたり"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2539
  override val PILATES = "ピラティス"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2549
  override val PILATES_GOOGLE_FIT_DESCRIPTION = "ピラティスワークアウト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3943
  override val PLAY = "再生"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=55
  override val PLAY_STORE_PRODUCT_PRICES_MESSAGE = "Playストアからの商品価格の取得中にエラーが発生しました"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=319
  override val PLAYLIST = "プレイリスト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=72
  override val PLAYLIST_TYPE_BUSY = "プレイリストの種類を変更する際に問題が発生しました。数秒後にもう一度お試しください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=73
  override val PLAYLIST_TYPE_NO_INTERNET_MESSAGE = "インターネットに接続されていないようです。音楽の種類を変更するには、再接続してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3049
  override fun POSE_DISLIKED_MESSAGE(p0: Any) = "私たちはあなたの将来の練習から${p0}を除外します"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1199
  override val POSE_LIBRARY_ANSWER = "現在ポーズ集は提供していませんが開発中です！しばらくお待ちください！\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1188
  override val POSE_LIBRARY_QUESTION = "各ポーズについて詳しく学べる、ポーズ集はありますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3048
  override fun POSE_LIKED_MESSAGE(p0: Any) = "私たちはあなたの未来の練習にもっと${p0}を追加します"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1532
  override val POSE_LIST = "ポーズリスト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3008
  override val POSE_LIST_DESCRIPTION = "以下のすべてのポーズを探索し、将来の練習でより多くまたは少なく見たいポーズを指定してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3252
  override val POSE_NAMES = "ポーズ名"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3071
  override val POSES = "ポーズ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=286
  override val PRACTICE = "練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1275
  override val PRACTICE_FEEDBACK = "練習のフィードバック"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=166
  override val PRACTICE_SAVED_CONFIRMATION = "練習がお気に入りに追加されました！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1515
  override val PRACTICE_STREAK_NOT_CAPITALIZED = "連続練習日数"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1293
  override fun PRACTICES_IN_MONTH(p0: Any) = "${p0}の練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=456
  override val PRENATAL = "マタニティヨガ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1200
  override val PRENATAL_ANSWER = "はい、Down Dog にはマタニティヨガ単独のアプリがあるので是非お試しください！マタニティヨガのアプリは<a href=\"https://play.google.com/store/apps/details?id=com.downdogapp.prenatal\" target=\"_blank\">Android</a> そして <a href=\"https://apps.apple.com/us/app/prenatal-yoga-down-dog/id1504152442\" target=\"_blank\">iOS</a>, または <a href=\"https://prenatal.downdogapp.com/web\" target=\"_blank\">prenatal.downdogapp.com/web</a>よりご利用いただけます。このアプリでは妊娠周期に合った練習ができます。メインのヨガアプリと同様に沢山のブースト機能に加えて、妊娠に特化したブーストもあります。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1189
  override val PRENATAL_QUESTION = "妊娠中です。マタニティヨガはありますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1267
  override val PRENATAL_SHORT = "マタニティ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2554
  override fun PREPARING_VIDEO_PROGRESS(p0: Any) = "ビデオを準備中... ${p0}% 完了"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2569
  override val PREPARING_VIDEO_WARNING = "私たちはあなたのビデオを準備しています。ダウンロードが始まるまでアプリを開いたままにするか、数分後にアプリに戻ってダウンロードを開始してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1405
  override val PRICE_DIFFERENCE_ANSWER = "<a href=\"/purchase\">ウェブサイトからの購入</a>では、AppleやGoogleが請求する手数料がなく、通常は最安値での提供となっています。当社のウェブサイトで、<b>クレジットカード</b>または<b> PayPal </b>を使用して購入できます。当社のWebサイトから購入すると、AppleまたはGoogleからアプリ内購入する場合と同様に、すべてのアプリにアクセスできます。コンピューター、電話、タブレットでWebサブスクリプションを使用できます。\n\nAppleまたはGoogleからアプリ内でサブスクリプションを購入することもできます。 AppleとGoogleは手数料を請求するため、通常、アプリ内価格が当社のWebサイトよりも高くなることに注意してください。\n\n*米国外での購入については、当社からの両替手数料は請求はありませんが、銀行からの請求が発生する場合もあるため、必ず確認してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1404
  override val PRICE_DIFFERENCE_QUESTION = "アプリ内価格がウェブ価格と異なるのはなぜですか？メンバーシップは異なりますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=287
  override val PRIVACY_POLICY = "プライバシーポリシー"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=398
  override val PROMOTIONAL_EMAILS = "プロモーションメールを受け取る"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=351
  override fun RECEIPT_SENT_TO_EMAIL_MESSAGE(p0: Any) = "領収書は${p0}に送信されます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1461
  override val RECEIPTS_ANSWER = "サブスクリプションの購入後、サブスクリプションに関連付けられているメールアドレスに領収書を送信しています。\n\n残念ながら領収書は再送できません。領収書を探す場合は、メールの件名で「<b> Down Dog 領収書</b>」を検索してください。スパムフォルダも確認してください！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1460
  override val RECEIPTS_QUESTION = "サブスクリプション購入の領収書を送ってもらえますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3799
  override val REDEEM = "引き換える"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3798
  override fun REDEEM_GIFT_INSTRUCTIONS(p0: Any, p1: Any) = "以下のボタンをクリックして、Down Dogの1年間の無料アクセスを獲得しましょう！ ギフト（コード ${p0}）は、ギフトを引き換えた日からあなたのアカウント ${p1} にクレジットされます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3797
  override val REDEEM_GIFT_VIEW_TITLE = "ダウンドッグギフトカードを引き換える"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1222
  override val REFUND_ANSWER = "Webからサブスクリプションの購読をし、返金を希望される場合は <a href=\"/support\">サポート</a> よりご連絡ください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1212
  override val REFUND_QUESTION = "返金を受けるにはどうすればよいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1424
  override val REFUNDED_ON_WAY = "払い戻しを処理しています。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=626
  override val REMOVE_FROM_FAVORITES = "お気に入りから削除"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=625
  override val REMOVE_FROM_HISTORY = "履歴から削除"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=663
  override val REMOVE_FROM_HISTORY_MESSAGE = "この練習を履歴から削除してもよろしいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1206
  override val RENAME_FAVORITES_ANSWER = "あります！ [<b>お気に入り</b>]画面で[<b>名前を編集</b>]をタップすると好きな名前をつけることができます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1194
  override val RENAME_FAVORITES_QUESTION = "お気に入りの練習に名前を付けてわかりやすく保存する方法はありますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3421
  override fun REQUIRED_EMAIL_DOMAIN_ALERT(p0: Any) = "${p0} ドメインのメールアドレスを使用してサインインしてください！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1910
  override val RESET = "リセットする"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=154
  override fun RESET_PASSWORD_MESSAGE(p0: Any) = "パスワードをリセットするためのリンクが${p0}に送信されました："
  
  // https://worker.downdogapp.com/debug/appString?appStringId=167
  override val RESUME_PRACTICE = "練習を再開する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=169
  override val RESUME_PRACTICE_MESSAGE = "以前の練習を再開しますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2245
  override val RUNNING = "ランニング"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2255
  override val RUNNING_GOOGLE_FIT_DESCRIPTION = "ダウンドッグランニングワークアウト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=66
  override val SAFARI_OR_MOBILE_BROWSER_WARNING_MESSAGE = "携帯電話やタブレットで快適にご利用いただくために、App StoreまたはPlayストアからアプリをダウンロードしてください。デスクトップ/ラップトップコンピュータではChromeの使用を推奨します。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1480
  override val SALE_PRICE_ANSWER = "セールが開催されるときはいつでも、割引価格を得るには、当社の Web サイトから購入する必要があります。\n\n購入は、クレジット カードまたは PayPal を使用して、当社の Web サイトで行うことができます。国際取引の場合、両替手数料はかかりませんが、銀行に確認してください。\n\nサブスクリプションを既に購入していて、特別セールを利用したい場合は、現在の購入方法に応じて、いくつかの手順を実行する必要があります。サブスクリプションの購入は購入と同時に有効になり、現在のサブスクリプションはキャンセルされることに注意してください。現在のサブスクリプションの最後には追加されません。\n\n<em><b>ウェブサイト</b>または <b>Google Play</b></em> から購入した場合:\n\n現在のサブスクリプションを Web から購入した場合は、<b>設定</b>、次に <b>サブスクリプション</b> に移動して、現在のサブスクリプションをキャンセルします。 Google Play から購入した場合は、<a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\" から現在のサブスクリプションをキャンセルできます。 \">Google Play ストア</a>。現在のサブスクリプションをキャンセルした後、当社の Web サイトから新しいサブスクリプションを購入できます。\n\nキャンセルして再購入を選択した場合、一部返金はできませんのでご注意ください。限られた状況では、現在の購入の払い戻しを受ける資格がある場合があります。<a href=\"/support\">サポート</a>で [払い戻しを希望する] をクリックすると、払い戻しの資格があるかどうかを確認できます。払い戻しを受ける資格があり、<a href=\"/support\">サポート</a> の [払い戻しを希望] で払い戻しをリクエストして確認を受け取った場合、現在のサブスクリプションは自動的にキャンセルされます。その後、当社の Web サイトから新しいサブスクリプションを購入できます。\n\n<em><b>Apple</b></em> を通じてサブスクリプションを購入した場合:\n\n<a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">Apple App Store を通じて</a>サブスクリプションをキャンセルする必要があります。 Apple 経由で購入された場合の払い戻しリクエストには対応できませんのでご注意ください。 Apple を通じて現在のサブスクリプションをキャンセルした後、当社の Web サイトから新しいサブスクリプションを購入できます。通常、これが最もお得な価格です。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1479
  override val SALE_PRICE_QUESTION = "セールについてのメールが届きました！セール価格の入手方法は？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=198
  override val SANSKRIT_POSE_NAMES = "サンスクリット語のポーズ名"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=454
  override val SAVE = "保存する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=529
  override val SAVE_AND_UNLINK = "保存してリンク解除"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1204
  override val SAVE_FOR_OFFLINE_ANSWER = "はい！オフラインで使用するために練習を保存するには3つの方法があります。これはモバイルアプリでのみ機能し、ウェブでは機能しないことに注意してください。\n \n1. <b>お気に入り</b>画面から練習を作成して保存します（お気に入りページに進むには、スタート画面の下部にあるハートのアイコンをタップします）。 [<b>お気に入り</b>]ページに、[<b>新しい練習をダウンロード</b>]と書かれた大きな青いボタンが表示されます。それをタップすると、現在の設定（ホーム画面に表示されるもの）で練習が自動的にダウンロードされます。デバイスに保存されていることを示す下向き矢印が練習名の右側に表示されていることを確認します。\n \n2. <b>履歴</b>から練習を保存します。アクセスするには、<b>履歴</b>ページに移動します（スタート画面の下部にある時計アイコンをタップします）。下にスクロールして保存したい練習をタップします。下部に「<b>お気に入りに追加</b>」と表示されています。これを押すと、練習が<b>お気に入り</b>に保存されてオフラインで使用できるようになります（画面の下部にあるハートのアイコンをタップして、<b>お気に入り</b>に保存されていることを確認できます）。デバイスに保存されていることを示す下向き矢印が練習名の右側にあることを確認します。\n \n3.練習が終わったら、<b> [お気に入りに追加] </b>を押します。これを押すと、今行った練習が<b>お気に入り</b>ページ（下部のハートのアイコン）に保存されます。デバイスに保存されていることを示す下向き矢印が練習名の右側にあることを確認します。\n\nライセンスの制限により、オフラインの場合、保存されたお気に入りには音楽が含まれません。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1192
  override val SAVE_FOR_OFFLINE_QUESTION = "Down Dogをオフラインで使うことはできますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1205
  override val SAVE_TO_FAVORITES_ANSWER = "はい！\n\n<em>完了した練習を保存する</em>\n\n練習を終えた直後に保存したい場合は、練習後のページで<b>お気に入りに追加</b>をタップしてください。それにより、練習が<b>お気に入り</b>に保存され、練習にハートのアイコンが追加されます。 <b>お気に入り</b>にアクセスするには、<b>履歴</b>ページ（メイン画面の下部にある時計のアイコンからアクセス可能）から、ハートのアイコンが付いた履歴内の任意の練習をクリックするか、<b>すべて</b>から切り替えて<b>お気に入り</b>のみを表示します。\n\n<em>履歴から以前の練習を保存する</em>\n\n以前に行った練習を保存したい場合は、<b>履歴</b>ページに移動します（ホーム画面の下部にある時計のアイコンをタップします）。そこに到着したら、下にスクロールして保存したい練習をタップします。下部に<b>お気に入りに追加</b>という言葉が表示されます。それを押すと、練習が<b>お気に入り</b>に保存され、練習にハートのアイコンが追加されます。 <b>お気に入り</b>にアクセスするには、<b>履歴</b>ページから、ハートのアイコンが付いた履歴内の任意の練習をクリックするか、<b>すべて</b>から切り替えて<b>お気に入り</b>のみを表示します。\n\n<em>楽しい事実！</em>\n\n履歴にある練習（お気に入りであるかどうかに関わらず）はすべてラベルを付けることができます。履歴内の練習をタップし、<b>名前を編集</b>を選択します。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1193
  override val SAVE_TO_FAVORITES_QUESTION = "気に入った練習を保存する方法はありますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1458
  override val SCHOOL_MEMBERSHIPS = "学校会員"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2150
  override val SCORE = "スコア"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2151
  override val SCORE_HATE_IT = "1（嫌い）"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2152
  override val SCORE_LOVE_IT = "5（大好き）"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3951
  override val SEARCH = "検索"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3108
  override val SEARCH_FOR_A_POSE = "ポーズを検索する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3286
  override val SEARCH_FOR_AN_EXERCISE = "エクササイズを検索する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1601
  override val SEE_EXERCISES_ON_TIMELINE = "タイムラインでポーズを見る"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1587
  override val SEE_POSES_ON_TIMELINE = "タイムラインでポーズを見る"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=270
  override val SELECT = "選ぶ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=585
  override val SEND = "送る"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=149
  override val SEND_FEEDBACK = "フィードバックを送信"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1406
  override val SENDING_FEEDBACK_FAILED = "フィードバックを送信できませんでした"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2747
  override val SEQUENCE_LENGTH_INVALID = "申し訳ありませんが、現在の設定ではその長さを練習することはできません。別の長さを選択してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=297
  override val SET_PASSWORD = "パスワードを設定してください"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=430
  override val SETTINGS = "設定"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1177
  override val SETTINGS_FOR_BEGINNERS_ANSWER = "<b>ヨガ：</b>\n\n<em>あなたのレベルを設定する</em>\n\nヨガが初めての方は、練習設定の下にあるレベル<b>初級1</b>から始めることをお勧めします。\n\n<em>あなたの練習タイプを選ぶ</em>\n\n立位のポーズと床でのポーズを含むよりソフトな練習を希望する場合は、練習タイプ<b>ジェントル</b>を試してみてください。\n\n床でのポーズのみでリラックスした練習を希望する場合は、<b>リストラティブ</b>または<b>陰ヨガ</b>を試してみてください。これらはポーズを最も長く保つことができます。\n\nより速く、流れるような、エネルギッシュな練習を希望する場合は、<b>ビンヤサ</b>を試してみてください。\n\nもっと流れを減らし、チャトランガをスキップし、ポーズを長く保つことで熱を発生させたい場合は、<b>ハタヨガ</b>を試してみてください。\n\n<em>指導レベル</em>\n\n最も詳細な指導を受けるために、あなたの<b>指導</b>レベルを<b>フル</b>に設定します。\n\n<em>あなたの遷移速度と保持時間を設定する</em>\n\n練習をさらにゆっくりと行いたい場合は、<b>遷移速度</b>を<b>最も遅い</b>に、<b>保持時間</b>を<b>最も長い</b>に調整することをお勧めします。古い練習タイプではこれらの機能はサポートされていないことに注意してください。\n\n<em>ウォームアップとクールダウンを延長する</em>\n\nビンヤサ、ハタ、ジェントルの練習タイプでは、あなたの<b>ウォームアップ</b>と<b>クールダウン</b>を<b>延長</b>に調整します。古い練習タイプではこれらの機能はサポートされていないことに注意してください。\n\n<em>ポーズを「好き」または「除外」する</em>\nビンヤサ、ハタ、ジェントルの練習タイプでは、ポーズを「好き」に設定して練習でより頻繁に見るか、「嫌い」に設定して二度と見ないようにすることができます。\n\n\n<b>妊婦ヨガ：</b>\n\nヨガが初めての方は、設定ビューを上にスワイプして練習設定を見るところにあるレベル<b>初級1</b>から始めることをお勧めします。\n\nリラックスした練習を希望する場合は、<b>リストラティブ</b>から始めることをお勧めします。これはすべて床での作業で、ポーズを最も長く保つことができます。\n\n\n<b>瞑想：</b>\n\n瞑想が初めての方は、<b>最長の沈黙</b>を比較的短く保つことをお勧めします - デフォルトは2分ですが、より少ない沈黙とより多くのガイダンスを希望する場合は、30秒まで短縮することができます。また、<b>ガイダンス量</b>を<b>最大</b>に設定して、提供する指導を最大限に受けることもできます！\n\n\n<b>HIIT</b>\n\n私たちのデフォルトの設定は始めるのに最適な場所です！\n\nレベル1のHIITが難しい場合は、レベル0を試してみてください！ 各エクササイズで短い時間を過ごすことも試してみてください。これは、設定ビューを上にスワイプして練習の下で設定を調整することで調整できます。ここでは、エクササイズの長さを調整できます。5秒や10秒の違いがどれほど大きいか驚くでしょう！ また、全体のワークアウトの長さを短縮し、各エクササイズ間の回復時間を延長することもできます。\n\n私たちは2つの練習タイプ、<b>ローテーション</b>と<b>プログレッション</b>を提供しています。<b>プログレッション</b>を選択して、常に同じ順序で体の異なる部分を動かすか、<b>ローテーション</b>を選択して、異なる練習で順序を混ぜて体の異なる部分を動かすことができます！\n\n\n<b>バレエ：</b>\n\nワークアウトの長さを変えることで難易度を調整することができます。経験豊富なアスリートは15分または20分から始め、さらなるチャレンジを求める場合は時間を増やすことができます。初心者の場合は、毎日5分または隔日10分から始めることをお勧めします。続けていれば、あっという間に長時間のワークアウトに対応できるようになります！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1169
  override val SETTINGS_FOR_BEGINNERS_QUESTION = "私は初心者で何から始めたらよいかわかりません。練習を十分に楽しむにはどんな設定をしたら良いですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1061
  override val SEVEN_MINUTE = "7分間ワークアウト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=150
  override val SHARE = "シェア"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1246
  override val SHARE_PRACTICE_ANSWER = "練習が終わった後に、または<b>履歴</b>か<b>お気に入り</b>から[<b>この練習をシェアする</b>]をタップして、その練習を友達と共有するためのリンクを取得します。\n\n友達がリンクをクリックするとアプリに移動し、保存された練習についてのポップアップメッセージが表示されます。 [<b>はい</b>]をタップして、<b>お気に入り</b>に保存します。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1245
  override val SHARE_PRACTICE_QUESTION = "練習を友達にシェアするにはどうすれば良いですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1181
  override val SHARE_THIS_PRACTICE = "この練習をシェアする"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1235
  override val SHARED_PRACTICE = "シェアされた練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3257
  override val SHOW_EXERCISE_NAMES = "エクササイズ名を表示する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3343
  override val SHOW_LIKE_AND_EXCLUDE_BUTTONS = "「いいね」と「除外」ボタンを表示"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2085
  override val SHOW_OVERLAY = "「次へ」のテキストを表示"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2082
  override val SHOW_POSE_NAME = "ポーズ名を表示"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1555
  override val SHOW_SUBTITLES = "字幕を表示する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1728
  override val SIGN_UP = "サインアップ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=64
  override val SIGN_UP_LOGIN = "サインアップ/ログイン"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=271
  override val SKIP = "スキップ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1173
  override val SLOWER_PACE_ANSWER = "<b>ヨガ：</b>\n\nあなたの練習をゆっくりと行うために調整できるいくつかの設定があります - すべてを試してみることをお勧めします！\n\n<em>トランジションスピード</em>\n\nフル設定を表示するために上にスワイプします。 <b>タイミング</b>の下で、<b>トランジションスピード</b>をタップし、一つのポーズから別のポーズへの移行時間を最も長くするためにそれを<b>最も遅い</b>に設定し、次に<b>選択</b>をタップします。古い練習タイプはこの機能をサポートしていないことに注意してください。\n\n<em>ホールドの長さ</em>\n\nフル設定を表示するために上にスワイプします。 <b>タイミング</b>の下で、<b>ホールドの長さ</b>をタップし、各ポーズで最も長い時間を許すためにそれを<b>最も長い</b>に設定し、次に<b>選択</b>をタップします。古い練習タイプはこの機能をサポートしていないことに注意してください。\n\n<em>ウォームアップ</em>と<em>クールダウン</em>\n\nあなたの<b>ウォームアップ</b>と<b>クールダウン</b>を<b>延長</b>に設定します。古い練習タイプはこれらの機能をサポートしていないことに注意してください。\n\n<em>指導レベル</em>\n\n最も多くの指導とポインターを得るために、あなたの<b>指導</b>レベルを<b>フル</b>に設定することもできます。\n\n<em>練習タイプ</em>\n\nあなたの練習<b>タイプ</b>を<b>ジェントル</b>または<b>ハタ</b>に設定し、ヴィンヤサフロー/チャトランガを省くことも試してみてください。 または、さらにゆっくりとしたものを探しているなら、あなたの練習<b>タイプ</b>を<b>陰</b>、または<b>リストラティブ</b>に設定します！\n\n<b>妊娠中のヨガ：</b>\n\n設定ビューで上にスワイプし、各ポーズで最も時間を過ごすためにあなたの<b>ペース</b>を<b>最も遅い</b>に設定します。最も多くの指導とポインターを得るために、あなたの<b>指導</b>レベルを<b>完全な説明</b>に設定することもできます。\n\n<b>HIIT：</b>\n\n各エクササイズで過ごす時間を変更することができます。設定ビューで上にスワイプし、<b>練習</b>の下で<b>エクササイズの長さ</b>をタップします。エクササイズの間の休息時間も<b>リカバリー</b>をタップして調整することができます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1165
  override val SLOWER_PACE_QUESTION = "練習の速さをもう少し遅くするにはどうしたら良いですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=466
  override val SOCIAL = "ソーシャル"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2086
  override val SOMETHING_WENT_WRONG = "問題が発生しました"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1533
  override val SONG_LIST = "曲リスト"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=288
  override val SONGS_PLAYED = "再生された曲"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=272
  override val START = "開始"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1600
  override val START_PRACTICE = "練習を始める"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=89
  override val START_PRACTICE_NO_INTERNET_MESSAGE = "インターネットに接続されていないようです。新しい練習を開始するには、再接続してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2090
  override val START_SHARED_PRACTICE = "この共有練習を始めませんか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1507
  override val STAT_TYPE_SUBTITLE = "何をご覧になりたいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1506
  override val STAT_TYPE_TITLE = "記録を選択してください"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1390
  override val STUDENTS_FREE_UNTIL_JANUARY_1_LONG = "生徒と教師は無料会員資格が適用されます！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1268
  override val SUBJECT_COLON = "件名："
  
  // https://worker.downdogapp.com/debug/appString?appStringId=273
  override val SUBMIT = "送信する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1266
  override val SUBMITTING = "送信しています..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=477
  override val SUBSCRIPTION = "購読"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1223
  override val SUBSCRIPTION_RENEWAL_PRICE_ANSWER = "はい！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1213
  override val SUBSCRIPTION_RENEWAL_PRICE_QUESTION = "購読は購入時と同じ価格で更新されますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1389
  override fun SUBSCRIPTIONS_SUPPORT_MESSAGE(p0: Any) = "${p0}としてログインしています。アカウントのサブスクリプションは次のとおりです。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1288
  override val SUBTITLES_ANSWER = "クローズドキャプション/字幕は、提供されているすべての言語で利用できます！\n\nモバイルアプリの場合：\n1. 練習を始める\n2. 画面をタップして、歯車のアイコンを表示します。その画面から「字幕を表示する」をオンの位置に切り替えます。\n\nWebアプリの場合：\n1. 練習を始める\n2. 画面の右下にある<b> cc </b>アイコンをクリックして字幕をオンにします\n\n字幕をオフにするには、もう一度<b> cc </b>をクリックします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1287
  override val SUBTITLES_QUESTION = "クローズドキャプション/字幕機能はありますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=452
  override val SUCCESS = "成功"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1509
  override val SUNDAY = "日曜"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=500
  override val SUPPORT = "サポート"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2333
  override val SUPPORT_MANAGE_EXPECTATIONS_TEXT = "私たちは非常に小さな会社であり、1日に何千ものメッセージを受け取るため、応答を約束することはできませんが、迅速に返信できるように最善を尽くします。有料のお客様からのメッセージを優先することに注意してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1754
  override val SWIPE_DOWN_TO_START_PRACTICING = "下にスワイプして練習を開始します"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=262
  override val TAP_TO_BEGIN = "タップして開始"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1260
  override val TECH_ISSUES = "技術的な問題"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=289
  override val TERMS_OF_USE = "利用規約"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=303
  override val THANKS = "ありがとうございます"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2157
  override val THANKS_FOR_FILLING_OUT_THE_SURVEY = "アンケートにご記入いただきありがとうございます。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1265
  override val THIS_FORM_FIELD_IS_REQUIRED = "このフィールドを入力してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=615
  override val TIMELINE = "タイムライン"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2050
  override val TOGGLE_SHOW_MORE_SETTINGS = "トグルでその他の設定を表示"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2590
  override val TOO_MANY_DOWNLOADS = "同時ダウンロードの最大数に達しました。 1 つが終了するのを待ってから、もう一度お試しください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1248
  override val TOTAL_PRACTICES = "これまでの練習数"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1523
  override val TOTAL_PRACTICES_CAPITALIZED = "合計練習数"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1524
  override val TOTAL_PRACTICES_NOT_CAPITALIZED = "合計練習数"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1252
  override val TOTAL_TIME = "合計時間"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1521
  override val TOTAL_TIME_CAPITALIZED = "合計時間"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1522
  override val TOTAL_TIME_NOT_CAPITALIZED = "練習時間合計"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1137
  override val TROUBLESHOOTING = "トラブルシューティング"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=251
  override val TRY_AGAIN = "再試行する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1155
  override val TURN_OFF_MUSIC_ANSWER = "設定ビューを上にスワイプして[音楽]をタップしてから、音楽の種類で[<b>なし</b>]をタップすると、アプリ内音楽をオフにできます。\n \n自分の音楽を再生したい場合は、デバイス上の他のアプリから再生できます。ただし、携帯電話やタブレットでは、インストラクションの音声はデフォルトで最大音量になっているため、Spotify や iTunesなどからの音量より大きくするには、これだけでは不十分な場合があります。\n \nそのような場合は、外部スピーカーを使用して音楽を再生するか、ラップトップまたはデスクトップでWebバージョン（https://www.downdogapp.com/web）を使用してバックグラウンドで音楽の音量を下げることをお勧めします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1154
  override val TURN_OFF_MUSIC_QUESTION = "練習中に自分の好きな音楽を聴きたいです。音楽を完全に消すにはどうすればよいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2088
  override val UNABLE_TO_LOAD_PLAYBACK_URL = "ビデオを読み込めませんでした。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1276
  override val UNABLE_TO_OPEN_LINKED_PRACTICE = "リンクされた練習を開くことができません"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=998
  override val UNKNOWN_CAST_RECEIVER_NAME = "不明なデバイス"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1641
  override val UNLINK_FROM_APPLE = "Appleのリンクを解除"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1642
  override val UNLINK_FROM_APPLE_MESSAGE = "Appleのリンクを解除するためのパスワードを設定します。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=504
  override val UNLINK_FROM_FACEBOOK = "Facebookからリンク解除"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=506
  override val UNLINK_FROM_FACEBOOK_MESSAGE = "Facebookからリンクを解除するパスワードを設定します。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=505
  override val UNLINK_FROM_GOOGLE = "Googleからリンク解除"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=507
  override val UNLINK_FROM_GOOGLE_MESSAGE = "Googleからリンクを解除するパスワードを設定します。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1398
  override val UNLINK_GOOGLE_FACEBOOK_ANSWER = "1. [<b>設定</b>]に移動します。モバイルアプリでは、画面の右下にある3本線をタップします。ウェブでは、設定は左側のサイドバーにあります。\n2. [<b>アカウント</b>]で、[<b>リンクをGoogleから解除</b>]（または[<b> Facebookからリンクを解除</b>）]をタップし、新しいパスワードを、パスワードとパスワード確認フィールドに入力します。\n3. [<b>保存</b>]をタップします。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1397
  override val UNLINK_GOOGLE_FACEBOOK_QUESTION = "Google / Facebookのリンクを解除し、代わりにメールアドレスとパスワードを使うにはどうすればよいですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=418
  override val UPDATE = "更新する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1226
  override val VIDEO_ACCIDENTALLY_MIRRORED_ANSWER = "全ての練習で反転している場合は、ミラーリング機能がオンになっていないことを確認してください。確認方法は次のとおりです。\n\nモバイルアプリ：\n1. 練習を始める。\n2. 画面の右上にある<b>右から２つ目のアイコン</b>をタップして表示を切り替えます。\n\nWebアプリ：\n1. 練習を始める。\n2. 画面の右下にある<b>左から3つ目のアイコン</b>をタップして、表示を切り替えます。\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1216
  override val VIDEO_ACCIDENTALLY_MIRRORED_QUESTION = "ビデオの映像はインストラクションと向きが逆です。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1225
  override val VIDEO_FREEZING_ANSWER = "以下のことを試してみてください：\n\n1. アプリをアンインストールして再インストールする\n\n2. 動画の品質を下げる。練習を開始し、一時停止します。右上の<b>ギアアイコン</b>をタップします。次に<b>ビデオ品質</b>をタップします。高品質と低品質のビデオのオプションが表示されるはずです。この設定はヨガアプリでのみ利用可能です。\n\n3. ウェブのみ：別のブラウザを試してみてください。Down DogはSafari、Firefox、Chromeで最もよく動作します。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1215
  override val VIDEO_FREEZING_QUESTION = "練習の途中で画面がフリーズしました。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1201
  override val VIDEO_MODEL_ANSWER = "今のところは各アプリで一人のモデルのみです。今後選択肢を増やせるようにしたいと考えています。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1190
  override val VIDEO_MODEL_QUESTION = "映像に出るモデルは他にもいますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=670
  override val VIDEO_QUALITY = "映像クオリティ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2558
  override val VIEW_OFFLINE_PRACTICE = "オフラインの練習を見る"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1491
  override val VIEW_PLAYLIST_ANSWER = "練習を完了した後、または[<b>履歴</b>]ページに表示されている練習から、[<b>音楽</b>]をタップして、練習中に再生された曲のプレイリストを表示します。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1490
  override val VIEW_PLAYLIST_QUESTION = "練習中に流れた曲は何ですか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3109
  override val VIEW_POSES = "ポーズを見る"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=75
  override val VISUAL_TYPE_NO_INTERNET_MESSAGE = "インターネットに接続されていないようです。ビジュアルタイプを変更するには、再接続してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=290
  override val VOICE = "音声"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2159
  override val VOICE_ACTOR_NON_ENGLISH_SURVEY_INTRO = "私たちはアプリに新しい声優を追加しています、そして私たちはあなたの入力を望んでいます！以下の各音声の好みを1から5のスコアで教えてください。技術的/音質の問題は無視し、実際の音声と翻訳の自然な響きに注目してください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2154
  override val VOICE_ACTOR_SURVEY_INTRO = "私たちはアプリに新しい声優を追加しています、そして私たちはあなたの入力を望んでいます！以下のどの声が好きかを1から5までランク付けして教えてください。技術的/音質の問題はご容赦ください。また、好きな声を教えてください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1423
  override val WANT_REFUND_CONFIRMATION = "この支払いを払い戻しますか？サブスクリプションはキャンセルされ、すぐにアクセスできなくなります。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1508
  override val WEEK_START_TITLE = "何曜日から始めますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1518
  override val WEEKLY_GOAL = "週間目標"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1504
  override val WEEKLY_GOAL_SELECTOR_TITLE = "毎週の目標を設定する"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1505
  override val WEEKLY_GOAL_SUBTITLE = "週に何回練習をしますか？"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=569
  override val WHATS_UP = "こちらよりご連絡ください。"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1256
  override fun X_PERCENT_COMPLETE(p0: Any) = "${p0}％完了"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=378
  override val YEARLY = "毎年"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1289
  override val YEARLY_CAPITALIZED = "毎年"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1731
  override val YES_SIGN_UP = "はい、サインアップします"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=291
  override val YES_STRING = "はい"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1060
  override val YOGA = "ヨガ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=501
  override val YOGA_FOR_BEGINNERS = "初心者のためのヨガ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=757
  override val YOGA_GOOGLE_FIT_DESCRIPTION = "Down Dog ヨガの練習"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1493
  override val YOGA_NIDRA_INFO_ANSWER = "ヨガニドラは、深いリラクゼーションをもたらすガイド付き瞑想です。メインのヨガアプリでは、<b>タイプ</b>の下のプラクティスで見つけることができます。\n\n注意：<b>ヨガニドラは音声のみ</b>で、ビデオはありません。\n\n多くの人々は、アプリ内の<b>音楽</b>を自然の音、アンビエント、脳波、ピアノとストリングスに設定することを楽しんでいます。いくつか試して、自分が好きなものを見つけてみてください！\n\nヨガニドラが初めての方は、<b>指導タイプ</b>を<b>完全な説明</b>または<b>デフォルト</b>に設定して聞くことをお勧めします。\n\nまた、ヨガニドラを使って眠りにつくこともできます！ヨガニドラを練習タイプとして選択した後、<b>ブースト</b>に移動して、ブーストを<b>スリープ</b>に設定してください！"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1492
  override val YOGA_NIDRA_INFO_QUESTION = "ヨガニドラとは何ですか？"
}
